import React from 'react';

type BadgeIconProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
};

const createBadgeIcon =
  (paths: React.ReactNode): React.FC<BadgeIconProps> =>
  ({ size = 20, className, ...props }) =>
    (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        {paths}
      </svg>
    );

export const AdminBadgeIcon = createBadgeIcon(
  <>
    <path d="M12 3 4.5 6v5c0 5 3 8.5 7.5 10 4.5-1.5 7.5-5 7.5-10V6L12 3Z" />
    <path d="M9.5 12.5 12 15l3.5-3.5" />
    <path d="M12 8v2" />
  </>
);

export const SubscriberBadgeIcon = createBadgeIcon(
  <>
    <path d="m12 3 2.3 4.7 5.2.8-3.8 3.7.9 5.2L12 15.8 7.4 17.4l.9-5.2-3.8-3.7 5.2-.8L12 3Z" />
    <path d="M9.5 13.5c.8.8 2.2.8 3 0" />
  </>
);

export const PartnerBadgeIcon = createBadgeIcon(
  <>
    <path d="M7.5 4.5 12 2l4.5 2.5v5L12 12l-4.5-2.5v-5Z" />
    <path d="M4 9.5 8.5 12v5L4 19.5V9.5Z" />
    <path d="M15.5 12 20 9.5v10L15.5 17v-5Z" />
  </>
);

export const PrivateBadgeIcon = createBadgeIcon(
  <>
    <rect x="5" y="10" width="14" height="9" rx="2" />
    <path d="M15 10V8a3 3 0 0 0-6 0v2" />
    <path d="M12 14v2" />
  </>
);

